import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { ImageDataModalRequired } from "../constants";
import ImageDisplay from "../../../core/img/imageDisplay";
import TextArea from "./TextArea";

const ImageHandlerModal = ({ id, onFinish, editData, DataRequired }) => {
  // const [ButtonNeeded, setButtonNeeded] = useState(false);

  const [file, setFile] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    // getValues,
    formState: { isSubmitting },
  } = useForm();

  useEffect(() => {
    if (editData) {
      setFile(null);
      setValue("dev", editData.dev);
      setValue("key", editData.key);
      setValue("image", editData.image);
      setValue("heading", editData.heading);
      setValue("subHeading", editData.subHeading);
      setValue("ctaBtn", editData.ctaBtn);
      setValue("ctaLink", editData.ctaLink);
    }
  }, [editData, setValue]);

  const onSubmit = async (data, event) => {
    event.preventDefault();
    const closeButton = document.querySelector(
      `#new-image-modal-${id} [data-bs-dismiss="modal"]`
    );

    if (closeButton) {
      closeButton.click();
      onFinish(data);
      setFile(null);
      reset();
    }
  };

  function handleChange(e) {
    console.log(e.target.files);
    setValue("image", e.target.files[0]);
    setFile(URL.createObjectURL(e.target.files[0]));
  }

  return (
    <div>
      {/* Edit Category */}
      <div className="modal fade" id={`new-image-modal-${id}`}>
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Image Handler</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {DataRequired.includes(ImageDataModalRequired.image) && (
                        <div className="mb-3 col-12">
                          <div className="image-upload download">
                            <input
                              type="file"
                              // {...register("file", {
                              //   required: "title is required",
                              //   onChange: () => setFileAdded(true),
                              // })}
                              onChange={handleChange}
                            />
                            <div className="image-uploads">
                              {file ? (
                                <div className="image-preview">
                                  <img src={file} />
                                </div>
                              ) : editData?.image ? (
                                editData?.dev &&
                                editData.image instanceof Blob ? (
                                  <div className="image-preview">
                                    <img
                                      src={URL.createObjectURL(editData.image)}
                                    />
                                    s
                                  </div>
                                ) : (
                                  <div className="image-preview">
                                    <ImageDisplay src={editData.image} />b
                                  </div>
                                )
                              ) : (
                                <ImageWithBasePath
                                  src={"assets/img/download-img.png"}
                                  alt="Uploaded preview"
                                />
                              )}

                              <h4>
                                {file
                                  ? "Image Uploaded Successfully"
                                  : "Drag and drop a Image to upload"}
                              </h4>
                            </div>
                          </div>
                        </div>
                      )}
                      {DataRequired.includes(
                        ImageDataModalRequired.heading
                      ) && (
                        <div className="mb-3">
                          <label className="form-label mb-3">Title</label>
                          <TextArea
                            control={control}
                            id="heading"
                            placeholder="Description"
                          />
                        </div>
                      )}
                      {DataRequired.includes(
                        ImageDataModalRequired.description
                      ) && (
                        <div className="mb-3">
                          <label className="form-label ">Description</label>

                          <TextArea
                            control={control}
                            id="subHeading"
                            placeholder="Description"
                          />
                        </div>
                      )}
                      {DataRequired.includes(
                        ImageDataModalRequired.buttonText
                      ) && (
                        <div className="mb-3 input-blocks">
                          <label className="form-label">Button text</label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("ctaBtn")}
                          />
                        </div>
                      )}
                      {DataRequired.includes(
                        ImageDataModalRequired.buttonLink
                      ) && (
                        <div className="mb-3 input-blocks">
                          <label className="form-label">Button Link</label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("ctaLink")}
                          />
                        </div>
                      )}

                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                          // onClick={() => setButtonNeeded(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-submit"
                          type="button"
                          onClick={handleSubmit(onSubmit)}
                        >
                          {isSubmitting ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Update"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Category */}
    </div>
  );
};

export default ImageHandlerModal;
